<template>
    <b-modal :id="id" hide-footer :title="leaderboard.name" size="xl" body-class="leaderboard-details-modal">
      <b-row>
        <b-col md="7">

            <b-row class="prizes" v-if="leaderboard.prizes">
              <b-col>
                <b-card v-if="leaderboard.prizes.first && !leaderboard.prizes.first.hidden" class="border-0">
                  <div class="prize-title">
                    <h4 v-if="isRaffleMode">Option 1</h4>
                    <h4 v-else><img src="/static/images/icons/medals/gold-medal.svg" /> First Place</h4>
                  </div>
                  <b-card class="prize-item bg-light mt-1" v-if="leaderboard.prizes.first">
                    <b-img v-if="leaderboard.prizes.first.image" fluid :src="leaderboard.prizes.first.image.fileLocation"/>
                    <div style="height:100px;" v-else />
                    <b v-if="leaderboard.prizes.first.title">{{leaderboard.prizes.first.title}}</b>
                    <b v-else>&nbsp;</b>
                    <p v-if="leaderboard.prizes.first.description" class="grey">{{leaderboard.prizes.first.description}}</p>
                    <p v-else>&nbsp;</p>
                  </b-card>
                </b-card>
              </b-col>
            </b-row>

            <b-row v-if="leaderboard.prizes">
              <b-col>
                <b-card-group deck class="prizes" v-if="leaderboard.prizes">
                  <b-card v-if="leaderboard.prizes.second && !leaderboard.prizes.second.hidden" class="mr-0 border-0">
                    <div class="prize-title">
                      <h4 v-if="isRaffleMode">Option 2</h4>
                      <h4 v-else><img src="/static/images/icons/medals/silver-medal.svg" /> Second Place</h4>
                    </div>
                    <b-card class="prize-item bg-light m-0 mt-1" v-if="leaderboard.prizes.second">
                      <b-img v-if="leaderboard.prizes.second.image" fluid :src="leaderboard.prizes.second.image.fileLocation"/>
                      <div style="height:100px;" v-else />
                      <b v-if="leaderboard.prizes.second.title">{{leaderboard.prizes.second.title}}</b>
                      <b v-else>&nbsp;</b>
                      <p v-if="leaderboard.prizes.second.description" class="grey">{{leaderboard.prizes.second.description}}</p>
                      <p v-else>&nbsp;</p>
                    </b-card>
                  </b-card>

                  <b-card v-if="leaderboard.prizes.third && !leaderboard.prizes.third.hidden" class="ml-0 border-0">
                    <div class="prize-title">
                      <h4 v-if="isRaffleMode">Option 3</h4>
                      <h4 v-else><img src="/static/images/icons/medals/bronze-medal.svg" /> Third Place</h4>
                    </div>
                    <b-card class="prize-item bg-light m-0 mt-1">
                      <b-img v-if="leaderboard.prizes.third.image" fluid :src="leaderboard.prizes.third.image.fileLocation"/>
                      <div style="height:100px;" v-else/>
                      <b v-if="leaderboard.prizes.third.title">{{leaderboard.prizes.third.title}}</b>
                      <b v-else>&nbsp;</b>
                      <p v-if="leaderboard.prizes.third.description" class="grey">{{leaderboard.prizes.third.description}}</p>
                      <p v-else>&nbsp;</p>
                    </b-card>
                  </b-card>
                </b-card-group>
              </b-col>
            </b-row>

        </b-col>
        <b-col md="5">

          <b-card class="points-system" v-if="leaderboard.scores">
            <h2>How To Earn {{ isRaffleMode ? 'Tickets' : 'Points' }}</h2>
            <template v-for="(score, key) in leaderboard.scores">
              <b-row class="point-type" :key="`${key}-${score.id}`" v-if="!score.disabled">
                <b-col cols="2" class="icon-container">
                  <div class="bg-primary-a2 round-icon" v-if="score.icon"><font-awesome-icon :icon="score.icon" /></div>
                </b-col>
                <b-col cols="10" class="d-flex flex-column justify-content-center">
                  <span class="header" v-if="isRaffleMode">{{score.value | plural('ticket')}} earned for {{ score.label }}</span>
                  <span class="header" v-else>{{score.value | plural('point')}} earned for {{ score.label }}</span>
                  <span v-if="score.description">{{ score.description }}</span>
                </b-col>
              </b-row>
            </template>
            <b-row class="point-type" v-if="isRaffleMode && $root.company.handle === 'adecco'">
              <b-col cols="2" class="icon-container">
                <div class="bg-primary-a2 round-icon"><font-awesome-icon icon="handshake" /> </div>
              </b-col>
              <b-col cols="10" class="d-flex flex-column justify-content-center">
                <span class="header">Up to £1500 referral bonus for a hire</span>
                <span><a href="https://real-links-assets.s3.eu-west-2.amazonaws.com/adecco-kKZOQ/2019-11-11/19d8b7ea-e85f-4dfa-a144-3116c8bc13de/UK%20Refer%20a%20friend%20scheme%20poster%20FINAL%5B1%5D.pdf">See policy</a> for details</span>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
export default {
  props: {
    leaderboard: {
      type: Object,
      validate: p => p && p.id,
    },
    id: {
      type: String
    }
  },
  computed: {
    isRaffleMode() {
      const { raffleMode } = this.leaderboard || {};
      return raffleMode === true;
    },
  },
};
</script>

<style lang="scss">
.leaderboard-details-modal {
  .prize-title {
    h4 {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      line-height: 32px;
    }
  }
  .points-system {
    min-height: 325px;
    .point-type:nth-child(2) {
      color:  rgba(70, 75, 255, 1);
      background-color:  rgba(70, 75, 255, 0.05);
      .round-icon {
        color:  rgba(70, 75, 255, 1);
        background-color:  rgba(70, 75, 255, 0.15);
      }
    }
    .point-type:nth-child(3) {
      color:  rgba(221, 23, 177, 1);
      background-color:  rgba(221, 23, 177, 0.05);
      .round-icon {
        color:  rgba(221, 23, 177, 1);
        background-color:  rgba(221, 23, 177, 0.15);
      }
    }
    .point-type:nth-child(4) {
      background-color:  rgba(229, 52, 59, 0.05);
      color:  rgba(229, 52, 59,1);
      .round-icon {
        background-color:  rgba(229, 52, 59, 0.15);
        color:  rgba(229, 52, 59,1);
      }
    }
    .point-type:nth-child(5) {
      background-color:  rgba(0, 131, 255, 0.05);
      color:  rgba(0, 131, 255, 1);
      .round-icon {
        background-color:  rgba(0, 131, 255, 0.15);
        color:  rgba(0, 131, 255, 1);
      }
    }
    .point-type:nth-child(6) {
      background-color:  rgba(4, 143, 104, 0.05);
      color:  rgba(4, 143, 104, 1);
      .round-icon {
        background-color:  rgba(4, 143, 104, 0.15);
        color:  rgba(4, 143, 104, 1);
      }
    }
    .point-type {
      padding: 0.5em;
      margin: 1em 0.5em 1em 0.5em;
      .header {
        font-weight: bold;
      }
      .header, span {
        padding-left: 2px;
        display: block;
      }
      .icon-container {
        display: flex;
        align-items: center;
        .round-icon {
          height: 30px;
          width: 30px;
          margin-left : 10px;
          .svg-inline--fa {
            height: 20px;
            width: 20px;
            margin: 5px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/leaderboard-details-modal.vue